import { render, staticRenderFns } from "./adduser.vue?vue&type=template&id=c0714a04&scoped=true&"
import script from "./adduser.js?vue&type=script&lang=js&"
export * from "./adduser.js?vue&type=script&lang=js&"
import style0 from "./adduser.vue?vue&type=style&index=0&id=c0714a04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0714a04",
  null
  
)

export default component.exports